module.exports = __webpack_public_path__ + "img/404.102df349.svg";